import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { registerFcmToken } from '../../lib/useFcm'

const VAPID_PUBLIC_KEY = 'BBREj4PAwQawVHBRCEA_Ktja2gEVUskaoS587zbfgwYS7oRGoD7TWZStnr_rDID2GzAH7s3kcul86XaSfsb_MNE'

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return new Uint8Array([...rawData].map(c => c.charCodeAt(0)))
}

export default function AppTokenLogin() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'loading' | 'error'>('loading')
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    if (!token) { setStatus('error'); setErrorMsg('Lien invalide'); return }

    const baseURL = `${import.meta.env.VITE_API_URL || ''}/api`

    axios.get(`${baseURL}/employee/auth/token/${token}`)
      .then(async r => {
        const { token: jwt, employee } = r.data
        localStorage.setItem('employeeToken', jwt)
        localStorage.setItem('employeeData', JSON.stringify({
          id: employee.id,
          firstName: employee.firstName,
          lastName: employee.lastName,
          establishmentId: employee.establishmentId || employee.establishment?.id,
          establishment: employee.establishment,
          appToken: token
        }))

        // Activer push notifications si supporté
        if ('serviceWorker' in navigator && 'PushManager' in window) {
          try {
            const permission = await Notification.requestPermission()
            if (permission === 'granted') {
              const reg = await navigator.serviceWorker.ready
              let sub = await reg.pushManager.getSubscription()
              if (!sub) {
                sub = await reg.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
                })
              }
              await axios.post(`${baseURL}/employee/me/push-subscription`,
                { subscription: sub.toJSON() },
                { headers: { Authorization: `Bearer ${jwt}` } }
              )
            }
          } catch { /* push non critique */ }
        }

        registerFcmToken()
        navigate('/app/home', { replace: true })
      })
      .catch(e => {
        setStatus('error')
        setErrorMsg(e.response?.data?.error || 'Lien invalide ou expiré')
      })
  }, [token, navigate])

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600 font-medium">Connexion en cours...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow p-8 max-w-sm w-full text-center">
        <div className="text-4xl mb-4">🔗</div>
        <h2 className="text-lg font-bold text-gray-900 mb-2">Lien invalide</h2>
        <p className="text-sm text-gray-500">{errorMsg}</p>
        <p className="text-xs text-gray-400 mt-4">Demande un nouveau lien à ton responsable.</p>
      </div>
    </div>
  )
}
